import $ from 'jquery';

export const isCountryAt = (() => {
  return $('html').attr('lang') === 'de-AT';
})();
